export default __webpack_public_path__ + "547f87677c687d90a76e7ae6a90c07bd.svg";